<template>
    <div class="my-dropdown" v-show="show" @mouseenter="mouseenter">
        <slot/>
        <div class="ant-dropdown ant-dropdown-menu" ref="content">
            <slot name="overlay"/>
        </div>
    </div>

</template>

<script>
export default {
    name: "dropdown",
    data() {
        return {
            show: false
        }
    },
    mounted() {
        setTimeout(() => {
          try {
            const children = this.$slots.overlay[0].elm.children;
            if (children && children.length){
              for (let i = 0; i < children.length; i++) {
                var style = window.getComputedStyle(children[i]);
                if (style.display !== 'none') {
                  this.show = true;
                  return
                }
              }
            }
          } catch (e) {}
        }, 100)
    },
  methods: {
    mouseenter(e){
      if (window.innerHeight - e.pageY < this.$refs.content.offsetHeight) {
        this.$refs.content.style.top = "auto";
        this.$refs.content.style.bottom = "20px";
      }
    }
  }
}
</script>

<style scoped lang="less">
.my-dropdown {
    display: inline-block;
    position: relative;

    &:hover {
        .ant-dropdown {
            display: block;
            animation: dropdown 0.05s linear;
        }
    }
}

/deep/ .ant-dropdown {
    display: none;
    position: absolute;
    left: 0;
    top: 20px;


    .ant-menu-item {
        height: 32px;
        line-height: 32px;
    }

    .ant-menu-item:hover {
        background-color: #e6f7ff;
    }
}
@keyframes dropdown {
    0%{
        transform: scaleY(.5);
        transform-origin: top;
    }
    100% {
        transform: scaleY(1)
    }
}
</style>
